import React from "react";
import { useSelector } from "react-redux";
import { RootState } from "@src/reducers/store";
import { MyBlueprintLibraryModal } from "@src/components/organisms/modals/blueprints/my-blueprint-library-modal/my-blueprint-library-modal";

export const BlueprintMyLibrary = () => {
  const showMyBlueprintLibraryModal = useSelector(
    (state: RootState) =>
      state.yourSlice.myBlueprintLibraryModal.showMyBlueprintLibraryModal,
  );

  return <>{showMyBlueprintLibraryModal && <MyBlueprintLibraryModal />}</>;
};
